import axios from 'axios';


export function base64ToBlob(base64, type) {
    const binary = atob(base64.split(',')[1]);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: type });
}

export function downloadBase64(fileObj) {

    var blob = this.base64ToBlob(fileObj.fileContent, fileObj.fileType);
    var url = window.URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = fileObj.fileName;
    a.click();

}

export function fileToBase64(file) {    
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}


export async function uploadBase64(filename, content) {
    
    var payload = {
        filename: filename,
        content: content
    }
    var config = await this.tokenLoad();
    return new Promise((resolve) => {
        axios.post(process.env.VUE_APP_API_URL + "/api/upload/base64", payload, config).then(res => {
            console.log(res.data);
            resolve(res.data);
        })
    })

}

export async function uploadFile(file) {
    
    // file formdata 업로드
    var form = new FormData();
    form.append("file", file);

    var config = await this.tokenLoad();
    return new Promise((resolve) => {
        axios.post(process.env.VUE_APP_API_URL + "/api/upload", form, config).then(res => {
            console.log(res.data);
            resolve(res.data);
        })
    })

}

export async function downloadFile(filename, save=false, download_filename="") {

    var url = process.env.VUE_APP_API_URL + "/api/download/" + filename

    if(save==true) {

        fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.blob();
        })
        .then(blob => {
            const new_url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = new_url;
            a.download = download_filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            // window.URL.revokeObjectURL(new_url);
        })
        .catch(error => console.error('Download error:', error));
    } else {
        // 브라우저로 다운로드
        window.open(url);
    }

    


    
}